export const LOCATION_MARKER = {
  imgUrl:
    'https://caterpillar.scene7.com/is/image/Caterpillar/CM20250113-354b8-b14f0',
  imgAlt: 'Location marker',
  mob: '?hei=28&wid=28&fmt=jpg&qlt=85,0&resMode=sharp2&op_usm=1.75,0.3,2,0',
  desk: '?hei=25&wid=22&fmt=jpg&qlt=85,0&resMode=sharp2&op_usm=1.75,0.3,2,0'
};
export const FIRST_AVAILABLE_IMG = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240314-2be2a-e2a6e',
  alt: 'FIRST AVAILABLE',
  size: '?hei=120&wid=180',
  width: 180,
  height: 120
};

export const EMAIL_METHOD = {
  translation: 'MA_EMAIL',
  isChecked: false,
  name: 'EMAIL'
};
export const PHONE_METHOD = {
  translation: 'CALL',
  isChecked: false,
  name: 'PHONE'
};
export const TEXT_METHOD = {
  translation: 'TEXT',
  isChecked: false,
  name: 'TEXT'
};

export const CONTACT_METHOD_TYPE = [EMAIL_METHOD, PHONE_METHOD, TEXT_METHOD];

export const DATE_TAB_INDEX = {
  FIRST_AVAILABLE: 0,
  CUSTOM: 1
};

export const ADD_SERIAL_PROMPT_MODAL_WIDTH = '340px';

export const NO_PREFERENCE = {
  translation: 'NO_PREFERENCE',
  is_checked: false,
  value: 'NO_PREFERENCE'
};
export const MORNING = {
  translation: 'MORNING',
  is_checked: false,
  value: 'MORNING'
};
export const AFTERNOON = {
  translation: 'AFTERNOON',
  is_checked: false,
  value: 'AFTERNOON'
};

export const SELECT_TIME_PREFERENCE = [NO_PREFERENCE, MORNING, AFTERNOON];

export const DESCRIPTION_CONTAINER = 0;
export const DATE_TIME_CONTAINER = 1;
export const CONTACT_CONTAINER = 2;

export const EMAIL_FORMAT_REGEX =
  /^[a-zA-Z0-9][-a-zA-Z0-9._+]+@([-a-zA-Z0-9]+\.)+[a-zA-Z]{2,5}$/;

export const PHONE_NUMBER_FORMAT_REGEX = /^[\d\s+\-()]*$/;

export const REQUEST_SERVICE_FORM_ATTRIBUTES = {
  prefDateType: {
    asap: 'ASAP',
    custom: 'CUSTOM'
  },

  contactType: {
    phone: 'PHONE',
    text: 'TEXT',
    email: 'EMAIL'
  }
};
export const REQUEST_SERVICE_MODEL_BUTTON = {
  CANCEL: 'CANCEL'
};

export const REQUIST_SERVICE_CUSTOM_WIDTH = '738px';
export const REQUEST_SERVICE_CONFORMATION_WIDTH = '554px';

export const MODAL_BREAKPOINTS = {
  md: '554px',
  sm: '339px'
};

export const REQUIST_SERVICE_CALENDER = {
  MIN_DATE: 0,
  MAX_DATE: 30
};

export const PHONE_NUMBER_MAXLENGTH = 20;

export const SUCCESS = 'success';
export const CAT = 'CAT';
export const GENERAL = 'GENERAL';

export const REFERENCE_TYPE = {
  COMMERCIAL_OFFER: 'COMMERCIAL_OFFER',
  GENERAL: 'GENERAL',
  TECH_UPGRADE: 'TECH_UPGRADE'
};

export const SUCCESSFULL = 'SUCCESSFULL';
export const FAILURE = 'FAILURE';

export const EQUIPMENT_IMAGE = {
  HEIGHT: 64,
  WIDTH: 88
};

export const NO_EQUIPMENT_IMAGE = {
  WIDTH: 200,
  HEIGHT: 132.5
};
export const SEARCH_NAME = 'searchEquipment';

export const REQUEST_SERVICE_EQUIPMENT_SEARCH =
  'request service equipment search';

export const NO_EQUIPMENT = {
  IMAGE_URL:
    'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240314-3513d-363e9',
  ALT: 'NO EQUIPMENT'
};
